<ng-container *ngIf="isChangeRequest; else default">
  <ng-container *ngIf="!showNetDelta; else netDelta">
    <ng-container *ngIf="!showDiff(fieldName); else diff">
      {{ valueFn ? valueFn(getFieldToDisplay(fieldName)) : getFieldToDisplay(fieldName) }}
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #netDelta>
  <span
    class="change-request-diff change-request-delta"
    [class.change-request-new]="netDeltaValue > 0"
    [class.change-request-old]="netDeltaValue < 0"
    [class.change-request-new-highlight]="netDeltaValue > 0 && highlightColors"
    [class.change-request-old-highlight]="netDeltaValue < 0 && highlightColors">
    {{ netDeltaValue > 0 ? '+' : '' }}{{ valueFn ? valueFn(netDeltaValue) : netDeltaValue }}
  </span>
</ng-template>

<ng-template #diff>
  <span class="change-request-diff">
    <span
      class="change-request-old"
      [ngClass]="{ 'change-request-old-highlight': highlightColors }">
      {{ valueFn ? valueFn(changes?.[fieldName]?.old) : changes?.[fieldName]?.old }}
    </span>
    <span
      class="change-request-new"
      [ngClass]="{ 'change-request-new-highlight': highlightColors }">
      {{ valueFn ? valueFn(changes?.[fieldName]?.new) : changes?.[fieldName]?.new }}
    </span>
  </span>
</ng-template>

<ng-template #default>
  {{ valueFn ? valueFn(getFieldValue()) : getFieldValue() }}
</ng-template>
